"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipIcon = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Bubble_1 = require("../Bubble");
var constants_1 = require("./constants");
/**
 * @internal
 */
exports.TooltipIcon = function (props) {
    var text = props.text, iconClass = props.iconClass, _a = props.arrowOffsets, arrowOffsets = _a === void 0 ? constants_1.ARROW_OFFSETS : _a, _b = props.alignPoints, alignPoints = _b === void 0 ? constants_1.ALIGN_POINTS : _b;
    return (react_1.default.createElement("span", null,
        react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0 },
            react_1.default.createElement("span", { className: classnames_1.default("gd-tooltip-icon", iconClass) }),
            react_1.default.createElement(Bubble_1.Bubble, { arrowOffsets: arrowOffsets, alignPoints: alignPoints }, text))));
};
//# sourceMappingURL=TooltipIcon.js.map